import { useEffect, useState } from "react";

const DEFAULT_CONFIG = {
    useThemeSelector: true,
    defaultTheme: "orangeTheme",
};

export function useClientConfig(path = `${process.env.PUBLIC_URL || ""}/clientConfig.js`) {
    const [config, setConfig] = useState(DEFAULT_CONFIG);

    useEffect(() => {
        if (typeof window === "undefined" || typeof document === "undefined") return;

        if (window.clientConfig) {
            setConfig({ ...DEFAULT_CONFIG, ...window.clientConfig });
            return;
        }

        const id = "client-config-script";
        let script = document.getElementById(id);
        if (!script) {
            script = document.createElement("script");
            script.id = id;
            script.async = true;
            script.src = path;
            document.body.appendChild(script);
        }

        const onLoad = () => setConfig({ ...DEFAULT_CONFIG, ...(window.clientConfig || {}) });
        const onError = () => setConfig({ ...DEFAULT_CONFIG });

        script.addEventListener("load", onLoad, { once: true });
        script.addEventListener("error", onError, { once: true });

        if (window.clientConfig) onLoad();

        return () => {
            script.removeEventListener("load", onLoad);
            script.removeEventListener("error", onError);
        };
    }, [path]);

    return config;
}